import React from 'react';
import {Route, Switch, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import Header from 'components/Header/index';
import Sidebar from 'containers/SideNav/index';
import Footer from 'components/Footer';
import {
  ABOVE_THE_HEADER,
  BELOW_THE_HEADER,
  COLLAPSED_DRAWER,
  FIXED_DRAWER,
  HORIZONTAL_NAVIGATION,
} from 'constants/ActionTypes';
import {isIOS, isMobile} from 'react-device-detect';
import asyncComponent from '../util/asyncComponent';
import TopNav from 'components/TopNav';

class App extends React.Component {

  render() {
    console.log(this.props);
    
    const {match, drawerType, navigationStyle, horizontalNavPosition} = this.props;
    const drawerStyle = drawerType.includes(FIXED_DRAWER) ? 'fixed-drawer' : drawerType.includes(COLLAPSED_DRAWER) ? 'collapsible-drawer' : 'mini-drawer';

    //set default height and overflow for iOS mobile Safari 10+ support.
    if (isIOS && isMobile) {
      document.body.classList.add('ios-mobile-view-height')
    }
    else if (document.body.classList.contains('ios-mobile-view-height')) {
      document.body.classList.remove('ios-mobile-view-height')
    }

    return (
      <div className={`app-container ${drawerStyle}`}>
        {/* <Tour/> */}

        <Sidebar/>
        <div className="app-main-container">
          <div
            className={`app-header ${navigationStyle === HORIZONTAL_NAVIGATION ? 'app-header-horizontal' : ''}`}>
            {(navigationStyle === HORIZONTAL_NAVIGATION && horizontalNavPosition === ABOVE_THE_HEADER) &&
            <TopNav styleName="app-top-header"/>}
            <Header/>
            {(navigationStyle === HORIZONTAL_NAVIGATION && horizontalNavPosition === BELOW_THE_HEADER) &&
            <TopNav/>}
          </div>

          <main className="app-main-content-wrapper">
            <div className="app-main-content">
              <Switch>
                
                <Route path={`${match.url}/clients`} component={asyncComponent(() => import('./routes/Clients'))}/>
                <Route path={`${match.url}/lotteries`} component={asyncComponent(() => import('./routes/Lotteries'))}/>         
                <Route path={`${match.url}/prizes`} component={asyncComponent(() => import('./routes/Prizes'))}/>         
                <Route path={`${match.url}/tickets`} component={asyncComponent(() => import('./routes/Tickets'))}/>        
                <Route path={`${match.url}/winning`} component={asyncComponent(() => import('./routes/Winners'))}/> 
                <Route path={`${match.url}/lotteryreport`} component={asyncComponent(() => import('./routes/LotteriesReport'))}/>  
                <Route path={`${match.url}/conversions`} component={asyncComponent(() => import('./routes/ConversionsReport'))}/>      
                <Route path={`${match.url}/dynamics`} component={asyncComponent(() => import('./routes/DynamicsReport'))}/> 
                <Route path={`${match.url}/files`} component={asyncComponent(() => import('./routes/Files'))}/>     
                <Route component={asyncComponent(() => import('components/Error404'))}/>
              </Switch>
            </div>
            <Footer/>
          </main>
        </div>
      </div>
    );
  }
}


const mapStateToProps = ({settings}) => {
  const {drawerType, navigationStyle, horizontalNavPosition} = settings;
  return {drawerType, navigationStyle, horizontalNavPosition}
};
export default withRouter(connect(mapStateToProps)(App));